import * as React from 'react'

import {
  CalendarClock,
  Circle,
  CircleCheck,
  CircleChevronDown,
  CircleDashed,
  Flag,
  FolderTree,
  Hash,
  Network,
  Paperclip,
  Radio,
  SquareCheck,
  Type,
  User,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

import { PermitFieldType } from '~/client/graph/types.generated'
import { PERMIT_FIELD_GLYPHS } from '~/client/src/shared/components/PermitFieldIcon/permitFieldGlyphs'
import type { OptionGlyph } from '~/client/src/shared/types/OptionGlyph'

export const OPTION_GLYPHS: Record<OptionGlyph | 'none', LucideIcon> = {
  name: Type,
  workflowCategory: CircleChevronDown,
  workflowType: CircleChevronDown,
  workflowStatus: CircleDashed,
  activeState: CircleCheck,
  date: PERMIT_FIELD_GLYPHS[PermitFieldType.StartFinishDates],
  time: PERMIT_FIELD_GLYPHS[PermitFieldType.Time],
  company: PERMIT_FIELD_GLYPHS[PermitFieldType.Company],
  contact: PERMIT_FIELD_GLYPHS[PermitFieldType.Assignee],
  user: User,
  location: PERMIT_FIELD_GLYPHS[PermitFieldType.Location],
  lbs: FolderTree,
  equipment: PERMIT_FIELD_GLYPHS[PermitFieldType.Equipment],
  material: PERMIT_FIELD_GLYPHS[PermitFieldType.Material],
  fileType: PERMIT_FIELD_GLYPHS[PermitFieldType.File],
  project: Flag,
  id: Hash,
  text: Type,
  number: Hash,
  select: CircleChevronDown,
  hierarchy: Network,
  checkbox: SquareCheck,
  datetime: CalendarClock,
  file: Paperclip,
  sensor: Radio,
  none: Circle,
}

export function renderOptionGlyph(
  glyph: OptionGlyph | 'none' | undefined,
): React.ReactNode {
  if (!glyph) return undefined
  const Glyph = OPTION_GLYPHS[glyph]
  return <Glyph />
}
